module.exports = __webpack_public_path__ + "img/ui-elem2@2x.6f656729.png";